export default __webpack_public_path__ + "static/2-dc0c97fc221a00d511240b561a632b8e.png";